import styled from 'styled-components'

export const ContainerGoodFakeMobile = styled.div`
    display: flex;
    padding: 0.2rem;
`
export const ImageBLockFakeMobile = styled.div`
    width: 125px;
    height: 125px;
    min-width: 125px;
`
export const ContainerContentBodyFakeMobile = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-left: 0.2rem;
    justify-content: space-between;
    gap: 5px;
    padding-top: 5px;
`
export const TitleFakeMobile = styled.div`
    height: 20px;
    width: 155px;
`
export const DescriptionFakeMobile = styled.div`
    height: 34px;
    width: 100%;
`
export const MnnFakeMobile = styled.div`
    height: 12px;
    width: 90px;
`
export const PriceLineFakeMobile = styled.div`
    display: flex;
    justify-content: space-between;
    height: 15px;
    width: 100%;
`
export const PriceStockLabelFakeMobile = styled.div`
    width: 124px;
`
export const PriceDeliveryLabelFakeMobile = styled.div`
    width: 111px;
`
export const PriceFakeMobile = styled.div`
    width: 41px;
`
export const BasketChangerLineFakeMobile = styled.div`
    display: flex;
    justify-content: space-between;
    height: 29px;
    width: 100%;
`
export const LikeFakeMobile = styled.div`
    width: 26px;
`
export const ButtonBasketFakeMobile = styled.div`
    width: 100px;
`
